/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileRefSchema } from './FileRefSchema';
import {
    FileRefSchemaFromJSON,
    FileRefSchemaFromJSONTyped,
    FileRefSchemaToJSON,
} from './FileRefSchema';

/**
 * 
 * @export
 * @interface InstancePhoneHomeResponseSchema
 */
export interface InstancePhoneHomeResponseSchema {
    /**
     * 
     * @type {Array<FileRefSchema>}
     * @memberof InstancePhoneHomeResponseSchema
     */
    fileRefs?: Array<FileRefSchema>;
    /**
     * 
     * @type {boolean}
     * @memberof InstancePhoneHomeResponseSchema
     */
    hasFilestore?: boolean;
}

/**
 * Check if a given object implements the InstancePhoneHomeResponseSchema interface.
 */
export function instanceOfInstancePhoneHomeResponseSchema(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InstancePhoneHomeResponseSchemaFromJSON(json: any): InstancePhoneHomeResponseSchema {
    return InstancePhoneHomeResponseSchemaFromJSONTyped(json, false);
}

export function InstancePhoneHomeResponseSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstancePhoneHomeResponseSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileRefs': !exists(json, 'file_refs') ? undefined : ((json['file_refs'] as Array<any>).map(FileRefSchemaFromJSON)),
        'hasFilestore': !exists(json, 'has_filestore') ? undefined : json['has_filestore'],
    };
}

export function InstancePhoneHomeResponseSchemaToJSON(value?: InstancePhoneHomeResponseSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file_refs': value.fileRefs === undefined ? undefined : ((value.fileRefs as Array<any>).map(FileRefSchemaToJSON)),
        'has_filestore': value.hasFilestore,
    };
}

